import { ActivityResponse, ClientResponse } from 'generated';

import { BLUE, DARK, PRIMARY } from 'constants/colors';

import { Box, Card, SxProps } from '@mui/material';
import { CARD_WIDTH } from 'constants/widths';
import { useRef } from 'react';
import { getStackStyle } from '../../CardsView/utils/utils';
import { useNavParams, useSelector } from 'hooks';
import { ZoomLevel } from '../Header/ZoomLevelMenu';
import { View } from '../../enums';
import usePlanningEntity from '../../hooks/usePlanningEntity';
import { ActivityCard } from '../ActivityCard/ActivityCard';
import { Event } from '../../types';

type Props = {
  start: string;
  clients: ClientResponse[];
  activity: ActivityResponse;
  durationInSeconds: number;
  count: number;
  sx?: SxProps;
  mousePosition?: { x: number; y: number };
  amountSelected: number;
  activeEvent: Event | null;
};

export default function DragOverlay({
  clients,
  activity,
  count,
  sx,
  mousePosition,
  amountSelected,
  activeEvent
}: Props) {
  const client = clients[0];
  const cardTypeColor = !client && activity ? BLUE : PRIMARY;
  const { defaultZoomLevel } = useSelector((state) => state.preferences);
  const { params } = useNavParams();
  const view = params?.view as View;
  const [planningEntityTypePreference] = usePlanningEntity();
  const planningEntityType = planningEntityTypePreference[view];
  const height =
    defaultZoomLevel === ZoomLevel.COMPACT
      ? '27px'
      : defaultZoomLevel === ZoomLevel.STANDARD
      ? '50px'
      : '78px';

  const ref = useRef<HTMLDivElement>(null);

  const rect = document
    .getElementById('drag-overlay-ref')
    ?.getBoundingClientRect() || {
    right: 0,
    bottom: 0,
    width: 0,
    height: 0
  };

  const offsetX = (mousePosition?.x || 0) - rect.right + rect.width;
  const offsetY = (mousePosition?.y || 0) - rect.bottom + rect.height;

  return (
    <Box
      position="absolute"
      width={CARD_WIDTH}
      minHeight={80}
      id="drag-overlay-ref"
      sx={{
        ...sx,
        transform:
          mousePosition?.x && mousePosition?.y
            ? `translate(${offsetX * -1}px, ${offsetY * -1}px)`
            : 'initial'
      }}
      ref={ref}
    >
      {count > 1 ? (
        <Card
          variant="outlined"
          sx={{
            cursor: 'grabbing',
            boxSizing: 'border-box',
            padding: '4px 4px 2px 4px',
            borderRadius: 0,
            borderLeft:
              count < 1
                ? `4px solid ${cardTypeColor}`
                : '1px solid rgba(0, 0, 0, 0.12)',
            flexShrink: 0,
            overflow: 'hidden',
            position: 'absolute',
            width: '100%',
            height: height,
            boxShadow: getStackStyle(amountSelected)
          }}
        >
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            height={1}
            width={1}
          >
            {`${count} geselecteerd`}
          </Box>
        </Card>
      ) : (
        <ActivityCard
          selected={false}
          planningEntityId={activity?.entityId}
          planningEntityType={planningEntityType}
          {...(activeEvent as Event)}
          sx={{
            '& h4': {
              marginTop: '1px',
              color: DARK
            }
          }}
        />
      )}
    </Box>
  );
}
